import {
    CommonHeaderIntercepotr,
    LOGINEncryptInterceptor,
    LOGINDecryptInterceptor,
    VconsoleRequestInterceptor,
    VconsoleResponseInterceptor,
    ECDHEncryptInterceptor,
    ECDHDecryptInterceptor,
    SentryReportInterceptor,
} from '@fs/http'
import customizeHeaderInterceptor from './customizeHeaderInterceptor'
import mrInterceptor from './mrInterceptor'
import outsideH5LogoutInterceptor from './outsideH5LogoutInterceptor'
import cmhkLogoutInterceptor from './cmhkLogoutInterceptor'
import freezeAccountInterceptor from './freezeAccountInterceptor'
import { getLangType, isTHSApp } from '@/utils/tools'
import { getXSource } from '../http.tool'
import { getRunEnv } from '@/utils/env'
import { isHLApp, isInOutsideH5 } from '@fs/utils'
import thsLogoutInterceptor from './thsLogoutInterceptor'
import outsideH5ExtendSessionInterceptor from './outsideH5ExtendSessionInterceptor'
import { captureException } from '@sentry/vue'

const { VUE_APP_ENV, NODE_ENV, VUE_APP_PUBLIC_KEY, VUE_APP_SIGN_KEY } = process.env

let store = null

export default function (http, { isUseApp = true } = {}) {
    try {
        const ECDHKeys = {
            PUBLIC_KEY: VUE_APP_PUBLIC_KEY,
            SIGN_KEY: VUE_APP_SIGN_KEY,
        }

        http.registerInterceptor(
            'request',
            LOGINEncryptInterceptor({
                VUE_APP_ENV: VUE_APP_ENV,
            })
        )
        http.registerInterceptor('request', ECDHEncryptInterceptor(ECDHKeys))
        http.registerInterceptor('request', VconsoleRequestInterceptor())

        http.registerInterceptor('request', customizeHeaderInterceptor)

        // uin、session、lang、xSource、rndKey
        const sessionKey = getRunEnv() === 2 ? 'WTtoken' : 'session'
        const session = () => localStorage.getItem(sessionKey) || ''
        const uin = () => localStorage.getItem('uin') || ''
        const rndKey = () => localStorage.getItem('rndKey') || ''
        http.registerInterceptor(
            'request',
            CommonHeaderIntercepotr({
                uin,
                session,
                rndKey,
                lang: getLangType(),
                xSource: getXSource(),
                product: 'pages',
                NODE_ENV,
                channel: 'H5',
            })
        )

        http.registerInterceptor('request', async config => {
            if (!store) {
                store = (await import('@/store/login'))?.default
            }
            return config
        })

        http.registerInterceptor('response', ECDHDecryptInterceptor(ECDHKeys))
        http.registerInterceptor('response', LOGINDecryptInterceptor({ NODE_ENV }))
        http.registerInterceptor('response', SentryReportInterceptor(captureException, true))
        http.registerInterceptor('response', VconsoleResponseInterceptor())

        // 处理冻结
        http.registerInterceptor('response', freezeAccountInterceptor)
        if (!isHLApp()) {
            http.registerInterceptor('response', mrInterceptor)
            http.registerInterceptor('response', outsideH5LogoutInterceptor)
            http.registerInterceptor('response', cmhkLogoutInterceptor({ store }))
            http.registerInterceptor('response', thsLogoutInterceptor)
        }
        // 处理站外H5登录态展期
        if (isInOutsideH5()) http.registerInterceptor('response', outsideH5ExtendSessionInterceptor)
    } catch (e) {
        console.log(`Feng.chen:: 16:20:43 e ===> `, e)
    }
}
